import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import CreateResumeSuccessHeader from '../../components/Career/Success/CreateResumeSuccessHeader';
import PreviewContent from '../../components/Career/Preview/PreviewContent';
import CreateResumeSuccessBottom from '../../components/Career/Success/CreateResumeSuccessBottom';
import PreviewDownloadModal from '../../components/Career/Preview/PreviewDownloadModal';

import { ReactComponent as DownloadIcon } from '@repo/common/assets/icons/16px/icon_16px_download.svg';
import { BaseButton, useT } from '@repo/common';
import { useResumePdfDownload } from '../../utils/useResumePdfDownload';

const CreateResumeSuccess = () => {
  const t = useT();
  const { state } = useLocation();
  const { resumeId } = useParams();
  const resumeScore = state?.resumeScore;
  const resumeData = state?.resumeData;
  const resumeTitle = state?.resumeTitle;
  const isStandard = state?.isStandard ?? false;

  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const { handleDownload } = useResumePdfDownload(resumeData, resumeTitle);

  const handleOpenDownloadModal = () => setIsDownloadModalOpen(true);

  return (
    <div className='w-full min-h-screen flex flex-col items-center bg-grayscale-gray01 pt-10 px-4 pb-[180px] tabletH:px-[40px] tabletH:pt-[60px] tabletH:pb-0'>
      {isStandard ? (
        <CreateResumeSuccessHeader
          title={t('Saved and ready to apply', '저장 완료, 지원 준비 끝')}
          content={
            <>
              {t(
                'This is your standard resume now. ',
                '이 이력서가 대표 이력서로 설정되었어요. ',
              )}
              <br className='hidden md:block' />
              {t(
                "It's submitted when you apply — so check your details first.",
                '지원 시 이 이력서가 제출되니 내용을 먼저 확인해 주세요.',
              )}
            </>
          }
        />
      ) : (
        <CreateResumeSuccessHeader
          title={t('Resume saved', '이력서가 저장되었습니다')}
          content={
            <>
              {t(
                "This isn't your standard resume, ",
                '이 이력서는 대표 이력서가 아니라서 ',
              )}
              <br className='hidden md:block' />
              {t(
                "so it won't be submitted when you apply.",
                '지원 시 제출되지 않아요.',
              )}
            </>
          }
        />
      )}

      <div className='pb-[22px] tabletH:pb-6 relative'>
        <div className='absolute bottom-[34px] right-3 z-20'>
          <BaseButton
            type='text'
            size='s'
            iconPosition='before'
            icon={<DownloadIcon />}
            onClick={handleOpenDownloadModal}
          >
            PDF
          </BaseButton>
        </div>

        <PreviewContent
          resumeData={resumeData}
          resumeTitle={resumeTitle}
          isCreateSuccessPage
        />

        {isDownloadModalOpen && (
          <PreviewDownloadModal
            onClose={() => setIsDownloadModalOpen(false)}
            onDownload={handleDownload}
          />
        )}
      </div>

      {isStandard ? (
        <CreateResumeSuccessBottom
          resumeId={resumeId}
          title={t(
            'You can update it anytime in My resumes',
            '내 이력서에서 언제든지 수정할 수 있어요',
          )}
          buttonLabel={t('Apply with this resume', '이 이력서로 지원하기')}
        />
      ) : (
        <CreateResumeSuccessBottom
          resumeId={resumeId}
          title={t(
            'You can review it anytime in My resumes',
            '내 이력서에서 언제든지 확인할 수 있어요',
          )}
          buttonLabel={t('Set as standard resume', '대표 이력서로 설정하기')}
        />
      )}
    </div>
  );
};

export default CreateResumeSuccess;
